import React, { useState } from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Heart } from "lucide-react";
import { useStore } from "@/context/StoreContext";
import { money } from "@/lib/api";

export const ProductCard = ({ product, index = 0 }) => {
  const { toggleWishlist, isWished } = useStore();
  const [hover, setHover] = useState(false);
  const img = product.images?.[0];
  const alt = product.images?.[1] || img;
  const wished = isWished(product.handle);
  const soldOut = !product.available;

  return (
    <motion.div
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.6, delay: (index % 4) * 0.07 }}
      className="group"
      data-testid={`product-card-${product.handle}`}
    >
      <Link to={`/product/${product.handle}`} className="block">
        <div className="relative overflow-hidden bg-[#EAE8E2] aspect-[3/4]"
             onMouseEnter={() => setHover(true)} onMouseLeave={() => setHover(false)}>
          <img src={hover && alt ? alt : img} alt={product.title}
               className="w-full h-full object-cover transition-transform duration-700 ease-out group-hover:scale-105" loading="lazy" />
          {product.badge && (
            <span className={`absolute top-3 left-3 overline px-3 py-1.5 ${soldOut ? "bg-white/90 text-black/50" : "bg-[#0A0A0A] text-[#F4F2ED]"}`}>
              {product.badge}
            </span>
          )}
          {product.compareAtPrice && !soldOut && (
            <span className="absolute top-3 right-12 overline px-2 py-1.5 bg-[#FFFFFF] text-[#0A0A0A]">Sale</span>
          )}
          <button
            data-testid={`wishlist-toggle-${product.handle}`}
            onClick={(e) => { e.preventDefault(); toggleWishlist(product.handle); }}
            className="absolute top-3 right-3 w-8 h-8 flex items-center justify-center bg-white/80 backdrop-blur hover:bg-white transition-colors"
            aria-label="Add to wishlist"
          >
            <Heart size={15} strokeWidth={1.5} className={wished ? "fill-[#0A0A0A]" : ""} />
          </button>
        </div>
      </Link>
      <div className="pt-3 text-left">
        <Link to={`/product/${product.handle}`}>
          <h3 className="font-body text-xs sm:text-sm font-bold uppercase tracking-wider leading-snug hover:opacity-60 transition-opacity">{product.title}</h3>
        </Link>
        <p className="overline text-black/40 mt-1">{product.category}</p>
        <div className="mt-1.5 flex items-baseline gap-2">
          <span className="font-mono text-xs sm:text-sm font-medium">{money(product.price)}</span>
          {product.compareAtPrice && <span className="font-mono text-[11px] text-black/40 line-through">{money(product.compareAtPrice)}</span>}
        </div>
      </div>
    </motion.div>
  );
};
